import { FC } from 'react';

import BadgeWrapper, { BadgeProps } from '../../wrappers/BadgeWrapper';

/**
 * @remarks
 * **Accessibility:** Consumers should provide an `aria-label` via `componentsProps.badge['aria-label']`
 * to describe the badge content when it is not announced by other means.
 *
 * @example
 * ```tsx
 * <AtomBadge
 *   badgeContent={3}
 *   componentsProps={{
 *     badge: { 'aria-label': '3 unread notifications' }
 *   }}
 * >
 *   <NotificationIcon />
 * </AtomBadge>
 * ```
 */

export interface IAtomBadgeProps extends BadgeProps {
  testId?: string;
}

const AtomBadge: FC<IAtomBadgeProps> = ({ testId = 'atom-badge', children, ...props }) => {
  const resolvedTestId = ((props as Record<string, unknown>)['data-testid'] as string | undefined) ?? testId;
  const resolvedDataCy = ((props as Record<string, unknown>)['data-cy'] as string | undefined) ?? resolvedTestId;

  return (
    <BadgeWrapper {...props} data-testid={resolvedTestId} data-cy={resolvedDataCy}>
      {children}
    </BadgeWrapper>
  );
};

AtomBadge.displayName = 'AtomBadge';

export default AtomBadge;
